import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {ThemeProvider} from '@contexts/themeContext';
import {ShopProvider} from '@contexts/shopContext';
import {Provider} from 'react-redux';
import store from './app/store';
import ReactGA from 'react-ga4';


import tournament from '@tournaments';

// ID de medición del torneo activo (REACT_APP_PUBLIC_GA lo sobrescribe si existe)
ReactGA.initialize(process.env.REACT_APP_PUBLIC_GA || tournament.gaId);

ReactGA.send('pageview');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider>
                <ShopProvider>
                    <App/>
                </ShopProvider>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);
